import { Component } from '@angular/core';
import { IdeateChallengeComponent } from '../ideate-challenge.component';

@Component({
  selector: 'app-ideate-sub-challenge',
  templateUrl: './ideate-sub-challenge.component.html',
  styleUrls: ['./ideate-sub-challenge.component.scss']
})
export class IdeateSubChallengeComponent {

  constructor(public ideateChallengeComponent: IdeateChallengeComponent) { }

}
